import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
const SvgIconSkipToStart = (props) => (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", focusable: false, ...props, children: _jsx("path", { fillRule: "evenodd", d: "M16 7L9 12L16 17V7ZM9 12V7H7V17H9V12Z", clipRule: "evenodd" }, void 0) }, void 0));
const Memo = memo(SvgIconSkipToStart);
export default Memo;
//# sourceMappingURL=IconSkipToStart.js.map